import { 
    acceptContributor, 
    acceptInvitation, 
    acceptViewer, 
    declineInvitation, 
    declineRequest, 
    joinRoom, 
    sendInvitation, 
    sendJoiningRequest 
} from "../multiplayer/SocketConnection"
import { 
    addInvitation, 
    addPendingRequest, 
    removePendingRequest, 
    setMyJoiningRequest, 
    updateRoomData 
} from "../store/slice/roomSlice"
import { 
    ACCEPT, 
    ACCEPT_CONTRIBUTOR, 
    ACCEPT_VIEWER, 
    DECLINE, 
    INVITATION, 
    JOINING_REQUEST, 
    CONTRIBUTOR, 
    MIC_ENABLED
} from "../store/constants/sharedModeFields"
import { setCanModify, setCooperative, setNotification } from "../store/slice/privateSlice"
import * as webRTCHandler from "./webRTCHandler"
import store from "../store/store"

export const handleSendJoiningRequest = (data, roomId) => {
    const myJoiningRequest = store.getState().room.myJoiningRequest

    if (myJoiningRequest === roomId)
        store.dispatch(setMyJoiningRequest(false))
    else store.dispatch(setMyJoiningRequest(roomId))

    sendJoiningRequest(data)
}

export const handleSendInvitation = (data, role) => {
    const { joinerSocketId } = data

    store.dispatch(addInvitation({ socketId: joinerSocketId }))

    sendInvitation({...data, role})
}

const joinRoomSetUp = (data) => {
    const { flag, room } = data
    if (flag) {
        store.dispatch(updateRoomData(room))
        store.dispatch(setCooperative(true))
    } else store.dispatch(setNotification("You are not able to join..."))
}

export const handleRequestAcceptedAs = (socketId, role, roomId) => {
    const configuredStunServer = store.getState().room.configuredStunServer

    const newJoiner = {
        socketId,
        roomId,
        username: store.getState().user.data.username,
        role,
        muted: MIC_ENABLED
    }

    store.dispatch(setMyJoiningRequest(false))
    store.dispatch(setCanModify(role === CONTRIBUTOR))

    if (configuredStunServer)
        webRTCHandler.getLocalStreamPreview(store.getState().room.audioOnly, () => {
            joinRoom(newJoiner, joinRoomSetUp);
        });
    else
        joinRoom(newJoiner, joinRoomSetUp);

    store.dispatch(setNotification("You are accepted in room as a " + role))
}

export const newJoiningRequest = (joinerSocketId, joinerUsername) => {
    const pendingRequests = store.getState().room.pendingRequests

    if (pendingRequests.some(pr => pr.socketId === joinerSocketId)) {
        store.dispatch(removePendingRequest({ socketId: joinerSocketId, type: JOINING_REQUEST }))
        store.dispatch(setNotification(joinerUsername + " has cancelled join request"))
    } else {
        store.dispatch(setNotification({
            text: joinerUsername + " want join in your room",
            buttons: [ACCEPT_CONTRIBUTOR, ACCEPT_VIEWER, DECLINE],
            buttonTypes: ['primary', 'primary', 'danger'],
            data: { joinerSocketId },
            buttonFunctions: (key, data) => {
                switch (key) {
                    case ACCEPT_CONTRIBUTOR:
                        acceptContributor(data)
                        break;
                    case ACCEPT_VIEWER:
                        acceptViewer(data)
                        break;
                    case DECLINE:
                        declineRequest(data)
                        break;

                    default:
                        console.log('not yet implemented');
                        break;
                }
            }
        }))

        store.dispatch(addPendingRequest({
            socketId: joinerSocketId,
            username: joinerUsername,
            date: new Date(Date.now()).toDateString(),
            type: JOINING_REQUEST
        }))
    }
}

export const newInvitation = (inviterSocketId, inviterUsername, roomId, role) => {
    store.dispatch(setNotification({
        text: inviterUsername + " invite you in his room as " + role + ":",
        buttons: [ACCEPT, DECLINE],
        buttonTypes: ['primary', 'danger'],
        data: { inviterSocketId, inviterUsername, roomId, role },
        buttonFunctions: (key, data) => {
            switch (key) {
                case ACCEPT:
                    acceptInvitation(data)
                    break;
                case DECLINE:
                    declineInvitation(data)
                    break;

                default:
                    console.log('not yet implemented');
                    break;
            }
        }
    }))

    store.dispatch(addPendingRequest({
        socketId: inviterSocketId,
        username: inviterUsername,
        date: new Date(Date.now()).toDateString(),
        type: INVITATION
    }))
}